module.exports = __webpack_public_path__ + "beea13d1c6adebafb5407cc9b9c10341.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-768.webp
// module id = 230
// module chunks = 0